import { ContainerModule } from 'inversify';
import { PlayerModuleSymbol } from '../api';
import { HunspellService, HunspellServiceSymbol } from './hunspell-service'
import { HunspellPlayerModule } from './hunspell-player-module'

export const hunspellModule = new ContainerModule((bind) => {
  bind(HunspellServiceSymbol).to(HunspellService).inSingletonScope();
  bind(PlayerModuleSymbol).to(HunspellPlayerModule)
});
